"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconMasonryShovel1 = function IconMasonryShovel1(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M9.335 43h29.33q1.201-.93 2.276-2H33v-6h12.336q.504-.975.92-2h-3.961q.032-.274.035-.55a5.75 5.75 0 0 0-1.8-4.13 4.27 4.27 0 0 0-4.32-3.79c-.453 0-.904.064-1.34.19A6.62 6.62 0 0 0 30.31 23a6.46 6.46 0 0 0-6.4 5 5.32 5.32 0 0 0-3.57 5H1.745q.414 1.025.919 2H9v6H7.059a24 24 0 0 0 2.276 2M9.58 4.814l8.13 3.496.591-1.439.846.352.079.037q.108.06.175.15l2.546 3.335-5.803 5.798A2.61 2.61 0 0 0 18.008 21H39.22a2.61 2.61 0 0 0 1.846-4.458l-10.62-10.61a2.6 2.6 0 0 0-3.685.003L23.374 9.32l-2.38-3.116-.124-.154a2.54 2.54 0 0 0-.975-.68l-.834-.347.639-1.553-4.349-1.864q-1.27.493-2.467 1.119L17.1 4.53l-.469 1.139-5.088-2.188a24 24 0 0 0-1.964 1.332m13.591 7.535-5.614 5.609A.61.61 0 0 0 18 19h21.222a.61.61 0 0 0 .431-1.043L29.031 7.345a.6.6 0 0 0-.854.002l-3.58 3.576 1.407 1.842a.58.58 0 0 0 .382.228l.094.007H28a1 1 0 0 1 .117 1.993L28 15h-1.514a2.58 2.58 0 0 1-1.965-.888l-.116-.145zm-.83 20.65h18.002a5 5 0 0 0-.002-.52 3.9 3.9 0 0 0-1.82-3.19 2.3 2.3 0 0 0 0-.46 2.38 2.38 0 0 0-4.16-1.47A4.48 4.48 0 0 0 30.31 25a4.47 4.47 0 0 0-4.56 4.46v.24a3.4 3.4 0 0 0-3.41 3.3M31 35H11v6h20zm-1.5-4a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m-1.5.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m.5-2.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1",
    clipRule: "evenodd"
  })));
};

export { IconMasonryShovel1, IconMasonryShovel1 as default };
